import React from 'react'

export const Profile = () => {
  return (
    <div className='profile' id='home'>
    <div className="container py-5">
    <div className="row py-5">
      <div className="col-12 col-md-6 col-sm-12 col-lg-6 order-lg-1 order-2 mt-5 pt-2">
      <h1 className="fs-3 mt-5 fw-bold">Hello, my name is</h1>
        <h1 className="fs-1 my-1 fw-bolder textspace">Rohaan Telangur</h1>
        <h1 className="fs-3 my-2 fw-bold text-danger textspace">I'm a MERN Stack Developer</h1>
        <a href="/assets/Rohaan_Telangur_Resume.pdf" target="_blank">
        <button type="button" className="fw-bold px-5 my-3 btn btn-danger btn-lg">RESUME</button>
        </a>
      </div>
      <div className="col-12 col-md-6 col-sm-12 col-lg-6 order-lg-2 order-md-2 text-center pt-4">
      <img src="img/rtelangur.png" width={"50%"} className="rounded float-end" alt="..."/>
      </div>
    </div>
  </div>
    </div>
  )
}
